/** @module Sourcing/_MassActionsMixin */
define([
	"dojo/_base/declare",
	"csi/locale",
	"underscore"
], function(declare,locale,_) {

	return declare(null, {
		massActionSuccessMessage: null,
		massActionErrors: null,
		massActionErrorCNLs: null,

		/**
		 * @override
		 * Update the call list
		 */
		toWriter: function() {
			var urls = _.pluck(this.m_formData.getSelectedNodes(), "LatestRevision");
			var request = this.m_action.m_request;
			var w = this.m_writer;
			// batch size is set in C8-17094
			var batchSize = (this.m_action.m_id == "MassApproveSupplierItems" || this.m_action.m_id == "MassApproveSupplierResponses"? 5 : 1);
			w.callList(request.m_module, request.m_operation, urls, "URL", batchSize);
			w.addParameter("FaultTolerant", "true");

			return w;
		},

		/**
		 * @override
		 * Get mass action success message
		 */
		getSuccess: function() {
			return this.massActionSuccessMessage;
		},

		/**
		 * @override
		 * Add submit action
		 */
		addProxyActions: function(defView, defActions) {
			var submitButton = "";
			if (this.m_action.m_id == "MassApproveSupplierItems" || this.m_action.m_id == "MassApproveSupplierResponses") submitButton = "BUTTON_APPROVE";
			if (this.m_action.m_id == "MassReopenSupplierItems" || this.m_action.m_id == "MassReopenSupplierResponses")  submitButton = "BUTTON_REOPEN";
			if (this.m_action.m_id == "MassReviseSupplierItems" || this.m_action.m_id == "MassReviseSupplierResponses")  submitButton = "BUTTON_REVISE";
			if (this.m_action.m_id == "MassDeleteSupplierItems")  submitButton = "BUTTON_DELETE";
			if (this.m_action.m_id == "MassAbandonSupplierItems")  submitButton = "BUTTON_ABANDON";
			if (this.m_action.m_id == "MassCloseSupplierResponses")  submitButton = "BUTTON_CLOSE";
			if (this.m_action.m_id == "MassFreezeSupplierResponses")  submitButton = "BUTTON_FREEZE";
			defActions.addAction(this.getProxyAction(submitButton, false, {m_bSubmit: true}));
			this.inherited(arguments);
		},

		/**
		 * @override
		 * See if any failed
		 */
		onPublishResponse: function(response) {
			if (response.someFailed()) {
				var errorList = [];
				response.getErrorReports().forEach(function (er) {
					errorList.push(locale.parameterResource(er.Error, er.Param));
				})
				this.massActionErrors = errorList;
				this.massActionErrorCNLs = response.getErrorCNLs();
			}

			this.inherited(arguments);
		}
	});
});
